import axiosInstance from "./axiosConfig";

const API_URL = "/api/services";

// Backend supports query params: search, status
const getAllServices = async (search = "", status = "") => {
    const params = {};
    if (search) params.search = search;
    // Frontend 'status' might be object like {name: 'Enabled'}, map it
    if (status && status !== "All") params.status = status; // Backend expects 'Enabled'/'Disabled'

    const response = await axiosInstance.get(API_URL, { params });
    return response.data;
};

const createService = async (serviceData) => {
    const response = await axiosInstance.post(API_URL, serviceData);
    return response.data;
};

const updateService = async (id, serviceData) => {
    const response = await axiosInstance.put(`${API_URL}/${id}`, serviceData);
    return response.data;
};

const deleteService = async (id) => {
    const response = await axiosInstance.delete(`${API_URL}/${id}`);
    return response.data;
};

const exportServicesPdf = async () => {
    const response = await axiosInstance.get(`${API_URL}/export/pdf`, {
        responseType: 'blob',
    });
    return response.data;
};

const servicesService = {
    getAllServices,
    createService,
    updateService,
    deleteService,
    exportServicesPdf,
};

export default servicesService;
